import type {
    FC
} from "react";
import type ICommandGroupProps from "./type";

const CommandGroup: FC<ICommandGroupProps> = () => {
    return null;
};
export default Object.assign(CommandGroup, {
    commandPart: "group"
});
